import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=06ee0c5c&"
import script from "./Simple.vue?vue&type=script&lang=js&"
export * from "./Simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports